import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

interface PresentationViewerProps {
  title?: string;
  subtitle?: string;
  pptUrl: string;
  pptFilename?: string;
}

const PresentationViewer: React.FC<PresentationViewerProps> = ({
  title,
  subtitle,
  pptUrl,
  pptFilename,
}) => {

  const officeViewerUrl =
    `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(pptUrl)}`;

  return (
    <Box
      sx={{
        border: '1px solid #e5e7eb',
        borderRadius: '16px',
        overflow: 'hidden',
        bgcolor: '#fff',
        width: '100%',
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          px: 2,
          py: 1.5,
          background: 'linear-gradient(135deg,#4962e5,#7c5cf8)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <SlideshowIcon sx={{ color: '#fff' }} />

          <Box>
            <Typography sx={{ color: '#fff', fontWeight: 700 }}>
              {title || 'Presentation'}
            </Typography>

            {subtitle && (
              <Typography
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: 12,
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            component="a"
            href={pptUrl}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<OpenInFullIcon />}
            sx={{
              color: '#fff',
              borderColor: 'rgba(255,255,255,0.4)',
            }}
            variant="outlined"
            size="small"
          >
            Open
          </Button>

          <Button
            component="a"
            href={pptUrl}
            download={pptFilename}
            startIcon={<DownloadIcon />}
            sx={{
              bgcolor: '#fff',
            }}
            variant="contained"
            size="small"
          >
            Download
          </Button>
        </Box>
      </Box>

      {/* PPT PREVIEW */}
      <Box
        sx={{
          height: 500,
          bgcolor: '#f5f5f5',
        }}
      >
        <iframe
          title="ppt-preview"
          src={officeViewerUrl}
          width="100%"
          height="100%"
          style={{
            border: 'none',
          }}
        />
      </Box>
    </Box>
  );
};

export default PresentationViewer;